import {AppNewReleaseNotifierService} from 'app/features/apps/services/app-new-release-notifier.service';
import {Injectable} from '@angular/core';

@Injectable()
export class AppNewReleaseResolver {
    constructor(private newReleaseNotifier: AppNewReleaseNotifierService) {}

    resolve(): Promise<void> {
        return this.newReleaseNotifier.checkWarnings(null);
    }
}
